import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'pv-common-valet-disabled-dialog',
    templateUrl: './common-valet-disabled-dialog.component.html',
    styleUrls: ['./common-valet-disabled-dialog.component.scss'],
    standalone: false
})
export class CommonValetDisabledDialogComponent implements OnInit {

  @Output() submitEvent = new EventEmitter();

  public form: UntypedFormGroup;
  public reasons = [
    {value: 'process', name: 'Manquements de process répétitifs'},
    {value: 'speeding', name: 'Grand excès de vitesse'},
    {value: 'delay', name: 'Retards répétitifs'},
    {value: 'behavior', name: 'Comportement inapproprié'},
    {value: 'withdrawal', name: 'Absences / Plantages répétitifs'},
    {value: 'asked', name: 'Sur demande du Valet'},
    {value: 'hijacking', name: 'Détournement'},
    {value: 'accident', name: 'Sinistre'},
    {value: 'other', name: 'Autre'},
  ];

  constructor(protected dialogRef: NbDialogRef<CommonValetDisabledDialogComponent>,
              private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      disableReason: [null, Validators.required],
      disableComment: [null, Validators.required]
    });
  }

  cancel() {
    this.submitEvent.emit();
  }

  submit() {
    this.submitEvent.emit(this.form.getRawValue());
  }

}
